import { useCallback } from "react";
import { GroupsApi, useAPIAction } from "melco-shared-logic";

export interface StatisticsGroupsEditInterface {
  id: string;
  reportingMelcoMachineStatisticsModelsUpdateGroup: {
    name: string;
    machine_list: [];
  };
}

export const useStatisticsGroupsEdit = () => {
  const [StatisticsGroupsEdit] = useAPIAction(
    GroupsApi,
    async (api: GroupsApi, StatisticsGroupsEditDetails: any) => {
      const { id, name, machine_list } = StatisticsGroupsEditDetails;
      let data = await api.statisticsGroupsEdit({
        id: id,
        reportingMelcoMachineStatisticsModelsUpdateGroup: {
          name: name,
          machine_list: machine_list,
        },
      });

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "reporting.machinegroups.actions.update",
    }
  );

  return useCallback(
    async (StatisticsGroupsEditDetails: any) => {
      return await StatisticsGroupsEdit(StatisticsGroupsEditDetails);
    },
    [StatisticsGroupsEdit]
  );
};
